import { StandardEvents } from '@shopify/events';

let revision = 0;
let pending = 0;
let controller;

function dominantColor(items) {
  const counts = new Map();
  for (const item of items) {
    const option = item.options_with_values?.find(value => ['color', 'colour'].includes(String(value.name || '').trim().toLowerCase()));
    const color = String(option?.value || '').trim().toLowerCase();
    const quantity = Number(item.quantity);
    if (color && Number.isFinite(quantity) && quantity > 0) counts.set(color, (counts.get(color) || 0) + quantity);
  }
  let winner = '', maximum = 0, tied = false;
  for (const [color, count] of counts) {
    if (count > maximum) { winner = color; maximum = count; tied = false; }
    else if (count === maximum) tied = true;
  }
  return tied ? '' : winner;
}

async function refresh() {
  const current = ++revision;
  controller?.abort();
  controller = new AbortController();
  try {
    const response = await fetch(`${Theme.routes.cart_url}.js`, {
      credentials: 'same-origin', cache: 'no-store',
      headers: { Accept: 'application/json' }, signal: controller.signal,
    });
    if (!response.ok) return;
    const cart = await response.json();
    if (current !== revision || pending || !Array.isArray(cart.items)) return;
    document.documentElement.dataset.hdBrowseCartColor = dominantColor(cart.items);
    document.documentElement.dataset.hdBrowseCartProducts = JSON.stringify([...new Set(cart.items.filter(item => Number(item.quantity) > 0).map(item => String(item.product_id)).filter(id => /^\d+$/.test(id)))]);
    document.dispatchEvent(new CustomEvent('herdad:cart-color'));
  } catch {
    // Keep the usable server-rendered cards when the cart cannot be refreshed.
  }
}

document.addEventListener(StandardEvents.cartLinesUpdate, async event => {
  pending++;
  revision++;
  controller?.abort();
  try { await event.promise; } catch {} finally {
    pending--;
    if (!pending) refresh();
  }
});

window.addEventListener('pageshow', event => {
  if (event.persisted || performance.getEntriesByType('navigation')[0]?.type === 'back_forward') refresh();
});
window.addEventListener('pagehide', () => { revision++; controller?.abort(); });
